









import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { EnvironmentName } from '@/helper/enum';
import { Utils } from '@/helper/utils';


@Component({})
export default class FooterLayoutPage extends Vue {
    public footer:string;
    public created(){
        this.footer = Utils.AppEnvironmentTitle;
    }
}
